import { render } from "./VoidPageView.vue?vue&type=template&id=4bcd73ee"
const script = {}

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_9243d0548d070ce3cb63e50486d60596/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__